import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=37964f43&"
import script from "./createCustomer.vue?vue&type=script&lang=js&"
export * from "./createCustomer.vue?vue&type=script&lang=js&"
import style0 from "./createCustomer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./createCustomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports